import React, { useContext, useEffect } from "react"
import DynamicElementList from "components/DynamicElements/DynamicElementList"
import { Box, Button } from "@mui/material"
import DynamicElementForm from "components/DynamicElements/DynamicElementForm"
import HowToAddDynamicElementsModal from "components/DynamicElements/HowToAddDynamicElementsModal"
import { greyButtonStyle } from "common/buttons"
import i18n from "i18n"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import {
  FROM_PROJECT,
  useDynamicElements,
} from "hooks/DynamicElements/useDynamicElements"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { DYNAMIC_ELEMENTS } from "constants/entitlements"

const DynamicElementsProject = () => {
  const {
    dynamicElements,
    dispatches,
    isHowToAddModalOpen,
    dynamicElementsConfig,
  } = useDynamicElements()

  const { projectId } = useParams()

  const organizationId = projectId
  useEffect(() => {
    dispatches.setIsFromProject(true)
    if (dynamicElementsConfig.showProjectInitialModal) {
      dispatches.setIsHowToAddModalOpen(true)
    }
    return () => {
      // Esta función se ejecuta al desmontar el componente
      dispatches.setDynamicElementsToInitialState()
    }
  }, [])

  const handleOnUpdate = () => {
    dispatches.getDynamicElementsConvertFrom(organizationId, FROM_PROJECT)
  }

  return (
    <EntitlementPageGuard permission={DYNAMIC_ELEMENTS}>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          marginInline: 20,
          marginBlock: 100,
        }}
      >
        {organizationId && (
          <>
            <DynamicElementList
              className={"mb-3"}
              organizationId={organizationId}
            >
              {dynamicElements && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      padding: 4,
                      borderRadius: 2,
                      border: "1px solid #E5E5E5",
                      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#f8f8f8",
                    }}
                  >
                    <DynamicElementForm poolId={organizationId} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      marginBottom: 1,
                      marginTop: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={greyButtonStyle}
                      onClick={handleOnUpdate}
                    >
                      {i18n.t("buttons.update")}
                    </Button>
                  </Box>
                </>
              )}
            </DynamicElementList>

            {dynamicElementsConfig.showProjectInitialModal && (
              <HowToAddDynamicElementsModal
                open={isHowToAddModalOpen}
                onClose={isOpen => {
                  dispatches.setIsHowToAddModalOpen(isOpen)
                  dispatches.setDynamicElementsConfig({
                    ...dynamicElementsConfig,
                    showProjectInitialModal: false,
                  })
                }}
                onUpdate={handleOnUpdate}
              />
            )}
          </>
        )}
      </div>
    </EntitlementPageGuard>
  )
}

export default DynamicElementsProject
